import { initialAdSlotOffsiteState, AdSlotOffsiteState } from 'mk2/containers/AdSlotOffsite/AdSlotOffsite.reducers';
import { AppState } from 'mk2/reducers';

export const getAdSlotOffsiteState = (state: AppState): AdSlotOffsiteState =>
    state.containers.global.adSlotOffsite || initialAdSlotOffsiteState;
